import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faGauge,
  faPenToSquare,
  faFile,
  faImages,
  faUsers,
  faGear,
  faRightFromBracket,
  faNewspaper
} from '@fortawesome/free-solid-svg-icons';
import '../pages/AdminDashboard.css';
import '../styles/AdminLayout.css';

const AdminLayout = ({ children }) => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  const handleLogout = async () => {
    await logout();
    navigate('/admin_v3jq5z');
  };

  const isActive = (path) => {
    return location.pathname === path ? 'active' : '';
  };

  const navigateTo = (path) => {
    navigate(path);
  };

  return (
    <div className="admin-dashboard">
      {/* Sidebar */}
      <div className="admin-sidebar">
        <div className="admin-sidebar-header">
          <FontAwesomeIcon icon={faNewspaper} />
          <h2>Blog Admin</h2>
        </div>
        
        {user && (
          <div 
            className="admin-user-profile"
            onClick={() => navigateTo('/admin_v3jq5z/profile')}
            style={{ cursor: 'pointer' }}
          >
            {(user.avatar && user.avatar.trim() !== '') ? (
              <img 
                src={`https://blog.bonlineco.com/storage/${user.avatar}`} 
                alt={user.name}
                className="admin-user-avatar"
                onError={(e) => { e.target.style.display = 'none'; }}
              />
            ) : (
              <div className="admin-user-avatar-placeholder">
                {user.name.charAt(0).toUpperCase()}
              </div>
            )}
            <div className="admin-user-info">
              <strong>{user.name}</strong>
              <span>{user.email}</span>
            </div>
          </div>
        )}
        
        <nav className="admin-sidebar-nav">
          <button 
            onClick={() => navigateTo('/admin_v3jq5z/dashboard')}
            className={`admin-nav-item ${isActive('/admin_v3jq5z/dashboard')}`}
          >
            <span className="admin-nav-icon"><FontAwesomeIcon icon={faGauge} /></span>
            <span>Dashboard</span>
          </button>
          <button 
            onClick={() => navigateTo('/admin_v3jq5z/posts')}
            className={`admin-nav-item ${isActive('/admin_v3jq5z/posts')}`}
          >
            <span className="admin-nav-icon"><FontAwesomeIcon icon={faPenToSquare} /></span>
            <span>Posts</span>
          </button>
          <button 
            onClick={() => navigateTo('/admin_v3jq5z/categories')}
            className={`admin-nav-item ${isActive('/admin_v3jq5z/categories')}`}
          >
            <span className="admin-nav-icon"><FontAwesomeIcon icon={faFile} /></span>
            <span>Categories</span>
          </button>
          <button 
            onClick={() => navigateTo('/admin_v3jq5z/media')}
            className={`admin-nav-item ${isActive('/admin_v3jq5z/media')}`}
          >
            <span className="admin-nav-icon"><FontAwesomeIcon icon={faImages} /></span>
            <span>Media</span>
          </button>
          <button 
            onClick={() => navigateTo('/admin_v3jq5z/users')}
            className={`admin-nav-item ${isActive('/admin_v3jq5z/users')}`}
          >
            <span className="admin-nav-icon"><FontAwesomeIcon icon={faUsers} /></span>
            <span>Users</span>
          </button>
          <button 
            onClick={() => navigateTo('/admin_v3jq5z/settings')}
            className={`admin-nav-item ${isActive('/admin_v3jq5z/settings')}`}
          >
            <span className="admin-nav-icon"><FontAwesomeIcon icon={faGear} /></span>
            <span>Settings</span>
          </button>
        </nav>
      </div>

      {/* Main Content */}
      <div className="admin-main">
        {/* Header */}
        <header className="admin-header">
          <div className="admin-header-left">
            <h1>{getPageTitle(location.pathname)}</h1>
          </div>
          <div className="admin-header-right">
            <div className="admin-user-menu">
              <span className="admin-user-name">{user?.name}</span>
              <button onClick={handleLogout} className="admin-logout-btn">
                <FontAwesomeIcon icon={faRightFromBracket} style={{ marginRight: '8px' }} />
                Logout
              </button>
            </div>
          </div>
        </header>

        {/* Content */}
        <main className="admin-content">
          {children}
        </main>
      </div>
    </div>
  );
};

const getPageTitle = (pathname) => {
  const titles = {
    '/admin_v3jq5z/dashboard': 'Dashboard',
    '/admin_v3jq5z/posts': 'Posts',
    '/admin_v3jq5z/categories': 'Categories',
    '/admin_v3jq5z/media': 'Media',
    '/admin_v3jq5z/users': 'Users',
    '/admin_v3jq5z/settings': 'Settings',
    '/admin_v3jq5z/profile': 'My Profile'
  };
  return titles[pathname] || 'Dashboard';
};

export default AdminLayout;
